import { Core } from "@/core/Core";

export default {

  /* Generic inventory entity */

  async getManyInventoryEntity(context, {entity, inventory, augment}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventory}/${entity}`, {augment, admin: true});
    } catch (e) {
      return null;
    }
  },

  async createInventoryEntity(context, {entity, inventory, data}) {
    try {
      return await Core.request("POST", `/api/inventory/${inventory}/${entity}`, data);
    } catch (e) {
      return null;
    }
  },

  async getOneInventoryEntity(context, {entity, inventory, id}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventory}/${entity}/${id}`);
    } catch (e) {
      return null;
    }
  },

  async saveInventoryEntity(context, {entity, inventory, id, data}) {
    try {
      return await Core.request("PUT", `/api/inventory/${inventory}/${entity}/${id}`, data);
    } catch (e) {
      return null;
    }
  },

  async deleteInventoryEntity(context, {entity, inventory, id}) {
    try {
      return await Core.request("DELETE", `/api/inventory/${inventory}/${entity}/${id}`);
    } catch (e) {
      return null;
    }
  },

  async getInventory(context, {id}) {
    try {
      return await Core.request("GET", `/api/inventory/${id}`);
    } catch (e) {
      return null;
    }
  },

  async saveInventory(context, {id, data}) {
    try {
      return await Core.request("PUT", `/api/inventory/${id}`, data);
    } catch (e) {
      return null;
    }
  },
}